import React from 'react';

export const MiniHeader = ({btn = false,details = false,menu = false,title, ...props}) => {

  return (
    <aside className={`dinfos-intv-mini-header${ menu ? ' dinfos-intv-mini-header--menu' : '' }`}>
      <div className="dinfos-intv-mini-header__text">

        { btn ? 
          <button type="button" className="btn dinfos-btn dinfos-intv-mini-header__title" data-overview>
            {title}
          </button>
        :
          <div className="dinfos-intv-mini-header__title">
            {title}
          </div>
        } 

        { details ?
        <div className="dinfos-intv-mini-header__details">
          {details}
        </div>
        : '' }


        { menu ? 
        <div className="dinfos-intv-mini-header__menu">
          {props.children}
        </div>
        : '' }
      </div>
      <hr className="dinfos-hr dinfos-hr--gold dinfos-hr--short" aria-hidden="true" />
    </aside>
  )
}